export const OFFSET = 10;

export const OUTS = [
  0, 1, 2
];

export const INNING = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
];

export const BALLS = [
  0, 1, 2, 3
];

export const STRIKES = [
  0, 1, 2
];

export const FIELDERS = {
  PITCHER: 'PITCHER',
  CATCHER: 'CATCHER',
  FIRSTBASE: 'FIRSTBASE',
  SECONDBASE: 'SECONDBASE',
  SHORTSTOP: 'SHORTSTOP',
  THIRDBASE: 'THIRDBASE',
  LEFTFIELD: 'LEFTFIELD',
  CENTERFIELD: 'CENTERFIELD',
  RIGHTFIELD: 'RIGHTFIELD'
};

export const RUNNERS = {
  BATSMAN:'BATSMAN',
  FIRSTRUNNER: 'FIRSTRUNNER',
  SECONDRUNNER: 'SECONDRUNNER',
  THIRDRUNNER: 'THIRDRUNNER'
}
export const DEFAULT_FIELDERS = [{
    position: FIELDERS.PITCHER,
    x: 293,
    y: 326
  }, {
    position: FIELDERS.CATCHER,
    x: 281,
    y: 436
  }, {
    position: FIELDERS.FIRSTBASE,
    x: 371,
    y: 273
  }, {
    position: FIELDERS.SECONDBASE,
    x: 333,
    y: 230
  }, {
    position: FIELDERS.SHORTSTOP,
    x: 224,
    y: 229
  }, {
    position: FIELDERS.THIRDBASE,
    x: 188,
    y: 282
  }, {
    position: FIELDERS.LEFTFIELD,
    x: 147,
    y: 211
  }, {
    position: FIELDERS.CENTERFIELD,
    x: 286,
    y: 148
  }, {
    position: FIELDERS.RIGHTFIELD,
    x: 420,
    y: 199
  }]
  export const DEFAULT_RUNNERS = [{
      position: RUNNERS.BATSMAN,
      visible: true,
      x: 281,
      y: 390
    },
    {
      position: RUNNERS.FIRSTRUNNER,
      visible: true,
      x: 368,
      y: 320
    },
    {
      position: RUNNERS.SECONDRUNNER,
      visible: false,
      x: 281,
      y: 233
    },
    {
      position: RUNNERS.THIRDRUNNER,
      visible: false,
      x: 194,
      y: 320
  }]
  export const DEFAULT_BALL = {
    position: BALLS.BALL,
    x: 256,
    y: 338
  }

  export const POLYGON_POINTS = [
    280, 1, 
    360, 79,
    461, 184,
    562, 283,
    544, 332,
    522, 372,
    481, 418,
    406, 466,
    345, 484,
    301, 490,
    260, 490,
    232, 488,
    183, 476,
    138, 457,
    115, 442,
    101, 432,
    64, 400,
    51, 385,
    37, 366,
    25, 343,
    13, 318,
    9, 308,
    2, 283,
    15, 270,
    114, 170,
    214, 72,
    280, 1
  ];

export const hatWebUrl = 'https://portal.acretrac.com/';
export const googleDocs = 'https://docs.google.com/gview?url=';
export const googleDocsViewer = "http://docs.google.com/viewer?url=";


// WEBPACK FOOTER //
// ./src/utils/constants.js